{
  "actions": {"handOff": "Hand off…", "remove": "Remove", "reopen": "Reopen"},
  "composer": {
    "add": "Add…",
    "addSearch": "Find an artifact or tool to insert",
    "cancelTurn": "Cancel",
    "cancelling": "Cancelling…",
    "cannotWrite": {
      "closed": "This Run is closed. Fork it to continue.",
      "savedNotHost": "This Run is not connected: the PC it runs on is offline, so only its owner can write. Fork it to continue on your own."
    },
    "hostChoosesAgent": "{{name}} hasn't chosen an agent yet.",
    "label": "Message",
    "outlook": {
      "cannotRun": "The agent can't answer on the PC this Run runs on: {{reason}}.",
      "joinsAfterApproval": "A tool waits for its approval on the PC this Run runs on. Your message waits and is handed over once that step has run.",
      "joinsAfterSlot": "The turn waits for free capacity on the PC this Run runs on and starts by itself. Your message waits and is handed over with the turn after it.",
      "joinsNextTurn": "The agent is working. Your message waits and is handed over with its next turn.",
      "runsWhenYouHost": "Runs on your own agent once this Run runs on your PC.",
      "waitsForHost": "The agent answers once the DMW Connector of the PC this Run runs on is online."
    },
    "placeholder": "Message the agent. @ inserts documents, artifacts, tools and your memories; / inserts skills and prompts.",
    "queue": "Queue for the agent",
    "send": "Send",
    "suggestions": {
      "kinds": {
        "artifact": "artifact",
        "document": "document",
        "memory": "memory",
        "prompt": "prompt template",
        "skill": "skill",
        "tool": "tool"
      },
      "label": "Suggestions",
      "someFailed": "Some suggestions could not be loaded."
    },
    "toolRun": {
      "loading": "Reading the tool…",
      "notJson": "Enter the value as JSON.",
      "open": "Run {{tool}} yourself…",
      "run": "Run {{tool}}"
    }
  },
  "current": {
    "cancelEdit": "Cancel",
    "change": "Change step",
    "edit": "Edit this step…",
    "editAndTryAgain": "Edit and try again…",
    "editQuestion": "Saving a changed step makes a new version of the process schema. Update this process schema, or save a derived process schema?",
    "entry": {
      "hostChooses": "The person on whose PC this Run runs chooses the document or segment.",
      "noCorpus": "This Run has no corpus to choose a document or segment from.",
      "question": "Which document or segment?"
    },
    "failed": "This attempt failed; its problem is in the log above. Nothing is tried again on its own.",
    "failedAgent": "This attempt failed; its problem is in the log above. A call that may have reached the provider is never repeated on its own, so check the log before you try again.",
    "filled": "Filled automatically ({{count}})",
    "inputs": {
      "changed": "Changed for this run",
      "choose": "Choose…",
      "chooseFor": "Choose an item for {{name}}",
      "chooseSearch": "Find an item in the library",
      "optional": "optional",
      "required": "required",
      "reset": "Reset",
      "results": {
        "choose": "Select a result.",
        "loading": "Loading results to decide…",
        "none": "No results are awaiting your decision."
      }
    },
    "label": "Current step",
    "newStep": "New step…",
    "recoveryStep": "Use a recovery step…",
    "run": "Run",
    "runAgain": "Run again from…",
    "runAgainFrom": "Run again from “{{step}}”",
    "runSavedNotHost": "While this Run is not connected, only the person on whose PC it runs can run this step. Run it on your PC to run the step yourself.",
    "skip": "Skip",
    "swap": "Swap for another step…",
    "tryAgain": "Try again"
  },
  "editStep": {"noItem": "This edit step names no item to edit."},
  "entry": {
    "agent": "Agent",
    "agentOf": "{{name}}'s agent",
    "copyReference": "Copy reference {{reference}}",
    "forkHere": "Fork at entry #{{number}}",
    "system": "DMW",
    "waitsForSender": "Waits until {{name}} takes over and runs it on their own agent.",
    "waitsForYou": "Waits until this Run runs on your PC and your own agent runs it."
  },
  "events": {
    "acceptForkOffer": "Fork here",
    "continuesWith": "Continues with step {{step}}.",
    "forkOffered": "Fork offered to {{user}} at #{{entry}}.",
    "forkedBy": "Forked by {{user}} from",
    "free": "without a process schema.",
    "fromOffer": "as offered in #{{entry}}",
    "hostChanged": "Now runs on the PC of {{to}}, before on the PC of {{from}}.",
    "hosting": {
      "closed": "Closed",
      "reopened": "Reopened",
      "saved": "Not connected",
      "went_live": "Connected"
    },
    "hostingLine": "{{change}}: {{reason}}",
    "hostingReasons": {
      "attached": "a DMW Connector was connected",
      "closed_by_participant": "closed",
      "connector_offline": "the DMW Connector went offline",
      "connector_returned": "the DMW Connector is back",
      "connector_revoked": "the DMW Connector was revoked",
      "detached": "the DMW Connector was disconnected",
      "hand_off": "hand-off",
      "reopened_by_host": "reopened by the person on whose PC it runs"
    },
    "noRoute": "no agent",
    "outcome": {
      "merge": "{{by}} merged the change set.",
      "reopen": "{{by}} reopened the change set.",
      "resubmit": "{{by}} resubmitted the change set.",
      "scrap": "{{by}} scrapped the change set.",
      "send_back": "{{by}} sent the change set back."
    },
    "problem": "Problem",
    "settingsChanged": "settings changed: runs with {{route}}, profile {{profile}}.",
    "started": "Started “{{title}}”",
    "titleChanged": "{{user}} renamed the Run to “{{title}}”.",
    "withSomeWorkflow": "with a process schema.",
    "withWorkflow": "with process schema “{{workflow}}”.",
    "workflow": {
      "completed": "Process schema completed.",
      "left": "Left the process schema; the conversation goes on freely.",
      "resumed": "Back on the process schema.",
      "runToStopped": "Stopped the run to a step.",
      "run_to": "Running to “{{step}}”.",
      "skipped": "Step {{step}} skipped.",
      "skippedOnTheWay": "“{{step}}” skipped on the way: the run doesn’t need it.",
      "started": "Process schema {{workflow}} started.",
      "switched": "Switched from “{{from}}” to “{{to}}” after “{{step}}”.",
      "switchedUnsettled": "Switched from “{{from}}” to “{{to}}”."
    }
  },
  "fork": {
    "atLatest": "Fork",
    "atThisEntry": "As at this entry",
    "corpusVersion": "Corpus version",
    "corpusVersionDetail": "On another version the fork works on the document as it is there, and its steps start again from the first one. The history up to here stays.",
    "defaultTitle": "{{title}} (fork at #{{entry}})",
    "explanation": "Continue from here in a copy of the Run’s history, which runs on your PC.",
    "loadingPoint": "Reading the versions at this entry…",
    "onNewest": "Run the fork on the newest content version and the newest version of this process schema",
    "onNewestDetail": "Merged changes to steps, prompts and labels apply in the fork. Steps before the first changed one keep their results, and the fork goes on from there.",
    "preview": {
      "continues": "runs from here",
      "failed": "failed; you can run it again",
      "kept": "keeps its result",
      "later": "runs after that",
      "loading": "Working out what the fork keeps…",
      "olderVersion": "Made with an older version of",
      "title": "What the fork keeps",
      "unnamedStep": "A step",
      "waiting": "waits for its answer, as it did"
    },
    "questionsTitle": "Questions from {{title}}",
    "submit": "Fork",
    "title": "Fork at entry #{{entry}}",
    "toQuestions": "Draft competency questions from these entries",
    "toQuestionsDetail": "From the annotations reviewed here, on the newest content version."
  },
  "handOff": {
    "copyLink": "Copy link",
    "forkOfferedBody": "The offer is in the Run; the recipient can fork there in one step.",
    "forkOfferedTitle": "Fork offered",
    "kinds": {
      "fork": {
        "description": "They get their own copy from here, running on their PC. This Run stays yours.",
        "title": "Offer a fork at #{{entry}}"
      },
      "hostRole": {
        "description": "If they accept, the agent runs on their PC with their account.",
        "title": "Let it run on their PC"
      }
    },
    "noMembers": "This project has no other members to hand off to.",
    "offerLinkHint": "{{recipient}} finds the offer in their Runs inbox. You can also send them this link. It expires {{expires}}.",
    "offerStates": {
      "accepted": "Offer accepted",
      "declined": "Offer declined",
      "expired": "Offer expired",
      "pending": "Offer sent",
      "withdrawn": "Offer withdrawn"
    },
    "pendingOffer": "To {{recipient}}, expires {{expires}}",
    "pendingTitle": "Your pending offers",
    "recipient": "To",
    "send": "Offer",
    "title": "Hand off",
    "withdraw": "Withdraw"
  },
  "header": {
    "askAgain": "Ask again",
    "asked": "Asked {{host}} to hand it over.",
    "change": "Change",
    "chooseWhere": "Choose where it runs…",
    "decline": "Decline",
    "forkAndRun": "Fork and run it yourself",
    "forkOf": "Fork of",
    "forkOfEntry": "the original Run, at #{{number}}",
    "forks_one": "{{count}} fork:",
    "forks_other": "{{count}} forks:",
    "handOver": "Hand it over",
    "importedExample": "Example Run, recorded {{date}} with {{model}}. Nothing here runs again.",
    "noConnector": "None of your DMW Connectors is online.",
    "notHandedOver": "{{host}} didn't hand it over.",
    "notRunning": "Not running.",
    "notRunningTheirs": "Not running: {{host}}'s PC is offline.",
    "referenceHint": "Copy the reference to this Run as it is now",
    "requestFrom": "{{name}} asks to run this Run on their PC.",
    "runOn": "Run on {{place}}",
    "runsOn": "Runs on: {{place}}",
    "runsOnAnotherPc": "Runs on: {{place}}, not this PC",
    "stepsDiffer_one": "{{count}} step differs",
    "stepsDiffer_other": "{{count}} steps differ",
    "takeOver": "Run on your PC",
    "theirPc": "{{host}}'s PC",
    "withdraw": "Withdraw",
    "workflow": "Process schema: {{name}}",
    "yourPc": "your PC"
  },
  "hostOffer": {
    "accept": "Run on your PC",
    "decline": "Decline",
    "explanation": "Its agent then runs on your PC and your subscription, for everyone in this Run.",
    "title": "{{host}} offers to let it run on your PC"
  },
  "hosting": {
    "approvalBlocksMove": "{{tools}} is waiting for approval. Answer or cancel it in the Run, then try again.",
    "attach": "Connect",
    "attachSubtitle": "Your PC runs the agent through your DMW Connector, for everyone in this Run.",
    "attachTitle": "Where it runs",
    "capabilities": {
      "context_tokens": "context size",
      "image_input": "image input",
      "reasoning": "reasoning",
      "skills": "skills",
      "text": "text",
      "tools": "tools"
    },
    "capabilityHint": "DMW checks per step whether the LLM can do what the step needs, and says so in the Run if not.",
    "checkAgain": "Check again",
    "connector": "DMW Connector",
    "connectorsLink": "Your DMW Connectors",
    "facts": {
      "assert": "Assert {{capability}} for this project…",
      "assertHint": "Add your team’s assessment in a capability correction for review.",
      "capability": "Capability",
      "conflict": "unknown: corrections disagree",
      "disagrees": "also {{value}} from",
      "no": "no",
      "none": "Nothing yet: neither the agent nor the provider has said what this LLM can do.",
      "openOverride": "correction",
      "outsideVocabulary": "Reported by the provider; not in DMW's capability vocabulary, so no step can require it yet.",
      "probeHint": "Or test it on your PC (one small request the provider may bill):",
      "refresh": "Look again on this PC",
      "refreshHint": "Reads the agents' LLMs and LLM catalogues and the API listings again; no LLM is asked anything.",
      "refreshing": "Asked the PC; the facts update when it reports back.",
      "source": "Where it comes from",
      "sources": {
        "observed": "Seen in turns",
        "override_host": "connector.toml on the PC it runs on",
        "override_installation": "Installation correction",
        "override_project": "Project correction",
        "probed": "Probed",
        "reported": "Reported"
      },
      "title_one": "What DMW knows about this LLM ({{count}} fact)",
      "title_other": "What DMW knows about this LLM ({{count}} facts)",
      "value": "Value",
      "yes": "yes"
    },
    "fallback": {
      "add": "Add",
      "chooseRoute": "Add a fallback route…",
      "down": "Move fallback {{position}} down",
      "help": "When a turn's own LLM route has a refused key or no credit left, it runs on the first of these that works. Another LLM route may bill another account.",
      "isOwn": "That is the Run's own LLM route.",
      "none": "None: a turn runs on its own LLM route or not at all.",
      "remove": "Remove fallback {{position}}",
      "removeShort": "Remove",
      "title": "Fallback routes, in order",
      "up": "Move fallback {{position}} up"
    },
    "fit": {
      "defaultToolsDropped": "This LLM route has no tools, so replies in this Run start without the memory tools.",
      "fits": "This LLM has what every turn of this Run requires.",
      "hint": "this agent reported about {{value}}; DMW can't confirm it",
      "lacksTitle": "This LLM cannot run every turn of this Run",
      "no": "lacks {{capability}}",
      "notChecked": "DMW could not check the LLMs now; it checks each step when it runs.",
      "replyTurns": "Replies",
      "step": "Step {{step}}",
      "uncertainTitle": "This LLM can run this Run; DMW does not know everything it needs yet",
      "unknown": "{{capability}} unknown",
      "unknownExplained": "The turns can run with unknown capabilities. Add your team’s assessment in a capability correction."
    },
    "loadingConnectors": "Loading your DMW Connectors…",
    "noAgents": "This DMW Connector reports no agents.",
    "noneOnlineBody": "Your paired DMW Connectors are not running. Start one on your PC, then check again:",
    "noneOnlineTitle": "No DMW Connector online",
    "nonePairedBody": "A Run runs its agent on your PC through the DMW Connector. Install it, then pair it with this account:",
    "nonePairedTitle": "No DMW Connector paired",
    "online": "online",
    "pairLink": "Pair a DMW Connector",
    "profile": "Permission profile",
    "unavailable": {
      "blocked": "key refused or no credit",
      "failed": "not working",
      "model_unavailable": "this LLM is not offered",
      "no_key": "no API key",
      "not_installed": "not installed",
      "not_logged_in": "not logged in"
    },
    "workspaceProfileChosen": "Step {{steps}} reads a file from your workspace: this profile opens it to reviewed tools.",
    "workspaceProfileMissing": "Step {{steps}} reads a file from your workspace, but this profile does not open it to tools. Choose a profile with item_tools_workspace; `just connector-status` lists them."
  },
  "humanStep": {
    "answerInCurrentStep": "Answer it in the current step, above the message box.",
    "answered": "Answers #{{entry}}",
    "choose": "Your choice",
    "chose": "chose {{choice}}",
    "comment": "Comment (optional)",
    "commentRequired": "Comment (required)",
    "confirm": "Confirm",
    "confirmedResult": "confirmed the reviewed result",
    "editedResult": "edited the reviewed result",
    "inCurrentStep": "Its inputs are in the current step.",
    "requested": "Asks a participant:",
    "reviewAnnotationsHint": "Select text to add an annotation, or choose an annotation in the text to change its label or remove it. To change a span, remove it and select the right text. Confirm the annotations as they are, or submit your changes.",
    "reviewHint": "Confirm it as it is, with a comment if needed.",
    "send": "Answer",
    "sentResult": "sent the reviewed result",
    "sentSet": "Annotations as sent",
    "submitEdited": "Submit changes",
    "superseded": "Superseded by a newer output. The step is asked again once the earlier step has run; an answer here changes nothing.",
    "title": "{{kind}} {{step}}",
    "workspaceFile": "Path of the file in your workspace ({{suffixes}})",
    "workspaceFileHint": "Relative to the workspace folder your DMW Connector opens to tools. The file stays on your PC; the next step reads it there and records its SHA-256."
  },
  "inbox": {
    "badge_one": "{{count}} Run offered to your PC",
    "badge_other": "{{count}} Runs offered to your PC",
    "expires": "Expires {{expires}}",
    "hostOffer": "{{from}} offers to run “{{title}}” on your PC",
    "hostRequest": "{{from}} asks to run “{{title}}” on their PC",
    "title": "Offers for you",
    "toolEffect": "Tool approval · Run {{tool}} on {{pc}}"
  },
  "list": {
    "chooseProject": "Choose a project to see its Runs.",
    "empty": "No Runs yet.",
    "fork": "Fork",
    "placement": {
      "custom": "Another time",
      "dropToPin": "Drop here to pin",
      "pin": "Pin",
      "pinned": "Pinned",
      "presets": {
        "evening": "This evening",
        "hour": "In 1 hour",
        "nextWeek": "Next week",
        "threeHours": "In 3 hours",
        "tomorrow": "Tomorrow"
      },
      "settle": "Settle",
      "settleTitle": "Settle: out of the list until you un-settle it",
      "settled": "Settled ({{count}})",
      "shared": "Shared ({{count}})",
      "snooze": "Snooze",
      "snoozeMenu": "Snooze “{{title}}”",
      "snoozed": "Snoozed ({{count}})",
      "snoozedUntil": "until {{time}}",
      "unpin": "Unpin",
      "unsettle": "Un-settle",
      "wake": "Wake now",
      "woke": "Woke",
      "wokeTitle": "Its snooze has ended. Opening it dismisses this.",
      "working": "Working ({{count}})"
    },
    "title": "Runs",
    "unread": "New entries"
  },
  "llm": {
    "choose": "Choose",
    "chooseUnderRunsWith": "Choose under Runs with",
    "chosen": "Chosen",
    "default": "Default",
    "defaultLevel": "Default ({{level}})",
    "defaultNamed": "Default ({{model}})",
    "effort": "Reasoning effort",
    "list": "LLMs",
    "loading": "Loading LLMs…",
    "noMatch": "No LLM matches.",
    "noStars": "No starred LLMs yet. Star one under All.",
    "notChosen": "No LLM chosen yet",
    "notOffered": "{{pc}}: {{reason}}. Choose another.",
    "ownForStep": "Own LLM for this step",
    "search": "Search LLMs",
    "seen": "Seen {{time}}",
    "show": "Show",
    "star": "Star {{model}}",
    "tabs": {"all": "All", "starred": "Starred"},
    "threadDefault": "Run default",
    "unstar": "Unstar {{model}}",
    "useThreadDefault": "Use the Run's default"
  },
  "log": {
    "earlier_one": "Show {{count}} earlier entry",
    "earlier_other": "Show earlier entries ({{count}} before these)",
    "label": "Entries",
    "loading": "Loading entries…",
    "orderBrokenBody_one": "The server sent an entry out of order or twice. It is shown in its right place; please report this.",
    "orderBrokenBody_other": "The server sent {{count}} entries out of order or twice. They are shown in their right place; please report this.",
    "orderBrokenTitle": "Entries arrived out of order",
    "refilling": "Catching up…"
  },
  "output": {
    "annotationAdd": "Add annotation",
    "annotationDelete": "Delete annotation",
    "annotationDetails": "Details",
    "annotationDocument": "Document version",
    "annotationLabel": "Label",
    "annotationLabelList": "Label list version",
    "annotationsInSegment": "Annotations in {{segment}}",
    "annotationsInText": "Annotations in the text",
    "annotationsLoading": "Loading the annotated text …",
    "annotationsUnplaced": "Not shown in the text:",
    "annotations_one": "{{count}} annotation of <document/> with labels from <labels/>",
    "annotations_other": "{{count}} annotations of <document/> with labels from <labels/>",
    "changeSetProposed": "Proposed a change set.",
    "inCurrentStep": "Shown in the current step",
    "instanceDataAbout": "About <document/> against the data model <model/>",
    "openReview": "Open review",
    "stepResult": "{{step}}: result",
    "title": "Step output"
  },
  "page": {"loading": "Loading Run…"},
  "people": {"unknown": "Unknown person", "you": "You"},
  "plan": {
    "askedAt": "Needs {{inputs}} of “{{step}}”: filled at that step above.",
    "askedFor": "Asked here for “{{step}}”",
    "elseDefault": "If it gives nothing: {{value}}",
    "gaveNothing": "“{{step}}” gave nothing, so the default applies",
    "list": "{{first}} and {{last}}",
    "parts": {"notFilled": "Not filled yet"},
    "producer": {
      "failed": "“{{step}}” failed and needs another try",
      "input": "“{{step}}” waits for an answer",
      "needs": "“{{step}}” needs input first",
      "offline": "“{{step}}” waits for the PC this Run runs on to reconnect",
      "queued": "“{{step}}” waits to start",
      "ready": "“{{step}}” can run now",
      "running": "“{{step}}” is running",
      "waiting": "“{{step}}” waits for free capacity",
      "waitingForApproval": "“{{step}}” waits for its tool’s approval",
      "waits": "“{{step}}” waits for {{steps}}"
    },
    "prompt": {"label": "Prompt", "source": "Prewritten in the step."},
    "reasons": {
      "abstract_workflow": "This process schema is used only inside a process schema that fills its abstract steps",
      "does_not_resolve": "The process schema’s steps do not resolve",
      "invalid_value": "“{{input}}” does not fit ({{kinds}})",
      "missing_context": "This Run still needs {{kinds}}",
      "missing_input": "“{{input}}” still needs a value",
      "not_a_value_input": "“{{input}}” takes no value",
      "unknown_input": "“{{input}}” is no input of the process schema"
    },
    "roles": {
      "abbreviation_table": "abbreviation table",
      "annotation_guideline": "annotation guideline",
      "corpus_description": "corpus description",
      "label_list": "label list",
      "publication_target": "publication target",
      "reference_vocabularies": "reference vocabularies",
      "released_module": "released ontology module",
      "segmentation_rules": "segmentation rules",
      "term_properties": "term properties"
    },
    "sources": {
      "carried_output": "Carried over from an earlier process schema",
      "context": "From this Run",
      "missing": "Enter a value",
      "missingFromThread": "Not set for this Run",
      "projectRole": "The project's {{role}}",
      "run_value": "Entered for this run",
      "step_default": "The step’s default",
      "wired_output": "Result of “{{step}}”",
      "wired_pending": "Filled by “{{step}}” when it runs",
      "workflow_default": "The process schema’s default"
    },
    "stepCount_one": "{{count}} step",
    "stepCount_other": "{{count}} steps",
    "waitsFor": "Waits for {{steps}}",
    "wiring": "The wiring passes the value on when the step runs."
  },
  "prepare": {
    "author": {
      "about": "About the {{kind}}",
      "agent": "With the agent",
      "agentHint": "The agent proposes changes to this version for review.",
      "answerHint": "Fills the first answer this process schema asks you for; you send it there.",
      "byHand": "By hand",
      "byHandHint": "Open the item's form here. Saving proposes a change set for review.",
      "byHandNote": "The form opens in this pane.",
      "byHandThread": "Fill in the form, then submit it for review.",
      "editTitle": "Improve: {{name}}",
      "how": "How",
      "message": "First message",
      "messageHint": "Sent as the Run's first message.",
      "newTitle": "New: {{name}}",
      "openForm": "Open the form"
    },
    "documents": {
      "chosen_one": "{{count}} document",
      "chosen_other": "{{count}} documents",
      "limit_one": "Work can cover at most {{count}} document.",
      "limit_other": "Work can cover at most {{count}} documents.",
      "overlap": "This document is already chosen, or it contains or lies inside a chosen segment.",
      "remove": "Remove {{document}}",
      "subject": "subject"
    },
    "earlier": {
      "branch": "Fork from a step…",
      "continue": "Continue",
      "hint": "Start fresh below, or continue one of these, or fork from one of its steps. A fork is a new Run; the earlier run stays as it is.",
      "open": "Open",
      "title": "Earlier runs on this document",
      "workflow": "Process schema"
    },
    "fork": {
      "atEntry": "Entry #{{entry}}, as it is",
      "beforeStep": "Before “{{step}}” (entry #{{entry}})",
      "point": "Fork from",
      "pointHint": "Keep the history before the step’s latest attempt and run the step again in the fork."
    },
    "invalidBody": "This address doesn't say what to start. Start again from the document, the process schema or the Runs list.",
    "invalidTitle": "Nothing to prepare",
    "memory": {
      "how": "Give the memory a title in the next step.",
      "noWorkflowBody": "It runs no \"Keep a memory\" process schema. Pin the DMW library in the project's settings, which ships it.",
      "noWorkflowTitle": "This project can't keep memories yet",
      "threadTitle": "Keep a memory: {{title}}"
    },
    "notYetBody": "This kind of work still starts from its own page. It moves into the Run view soon.",
    "notYetTitle": "Not prepared here yet",
    "release": {
      "intro": "Choose the results, destination and licence, then review the data release.",
      "noWorkflowBody": "None of this project's process schemas makes a data release. Its library version may predate the data release process schema; a library update brings it.",
      "noWorkflowTitle": "No data release process schema",
      "threadTitle": "Release the knowledge data"
    },
    "run": {
      "chooseAnother": "Choose another process schema…",
      "chooseEntry": "Choose the document or segment to work on.",
      "chosenMissingBody": "Choose a process schema below, or another content version under Versions.",
      "chosenMissingTitle": "This content version lacks the chosen process schema",
      "contentVersionHint": "Uses the newest content version by default.",
      "corpus": "Corpus: {{corpus}} at its latest version.",
      "free": "Without process schema",
      "freeHint": "A Run without process schema. You can still run steps later.",
      "freeTitle": "New run",
      "input": "{{label}}",
      "loadingVersions": "Loading content versions…",
      "loadingWorkflows": "Loading process schemas…",
      "missing": "Start needs {{items}}.",
      "missingEntry": "the document or segment to work on",
      "missingLlm": "Start needs an LLM for its agent steps.",
      "newThread": "New run",
      "newest": "Newest",
      "noContentBody": "This project is new: it has no content version and no process schemas yet. Start a Run without process schema now; that makes the project's first, empty content version.",
      "noContentTitle": "No process schemas yet",
      "noCorpus": "No corpus is chosen in Documents.",
      "noFittingWorkflows": "No process schema of this content version takes these documents.",
      "noWorkflows": "This content version has no process schemas.",
      "openWorkflow": "Open",
      "optionalInput": "{{label}} (optional)",
      "preparing": "Checking what the process schema’s steps need…",
      "quoted": "“{{input}}”",
      "start": "Start",
      "steps_one": "{{count}} step",
      "steps_other": "{{count}} steps",
      "takes": "Takes {{inputs}}.",
      "title": "Title: {{title}}.",
      "titleOnDocument": "{{name}} · {{document}}",
      "titleOnEntries_one": "{{name}} on {{count}} document",
      "titleOnEntries_other": "{{name}} on {{count}} documents",
      "versions": "Versions",
      "workflow": "Process schema",
      "worksOn": "Works on"
    },
    "starting": "Starting…",
    "titles": {
      "author": "Make a new item",
      "batch": "Run on many documents",
      "edit": "Work on an item",
      "fork": "Fork this Run",
      "import": "Import documents",
      "memory": "Keep as memory",
      "release": "Release the knowledge data",
      "run": "Start work"
    }
  },
  "progress": {
    "planStatus": {"completed": "Done", "in_progress": "Doing", "pending": "To do"},
    "toolCalls_one": "{{count}} tool call",
    "toolCalls_other": "{{count}} tool calls",
    "toolStatus": {
      "completed": "done",
      "failed": "failed",
      "in_progress": "running",
      "pending": "waiting"
    },
    "working": "The agent is working…"
  },
  "remove": {
    "goes": {
      "results_one": "{{count}} result",
      "results_other": "{{count}} results",
      "runs_one": "{{count}} Run",
      "runs_other": "{{count}} Runs"
    },
    "kept": {
      "already_erased_one": "{{count}} result already removed",
      "already_erased_other": "{{count}} results already removed",
      "change_sets_one": "{{count}} change set",
      "change_sets_other": "{{count}} change sets",
      "comments_one": "{{count}} comment or issue",
      "comments_other": "{{count}} comments or issues",
      "forks_one": "{{count}} fork",
      "forks_other": "{{count}} forks",
      "lineage_one": "{{count}} result of another Run",
      "lineage_other": "{{count}} results of other Runs",
      "memories_one": "{{count}} memory",
      "memories_other": "{{count}} memories",
      "moved_one": "{{count}} Run changed since it was closed",
      "moved_other": "{{count}} Runs changed since they were closed",
      "named_elsewhere_one": "{{count}} reference elsewhere",
      "named_elsewhere_other": "{{count}} references elsewhere",
      "recorded_since_one": "{{count}} result recorded since the list",
      "recorded_since_other": "{{count}} results recorded since the list",
      "releases_one": "{{count}} data release",
      "releases_other": "{{count}} data releases",
      "running_one": "{{count}} Run still working",
      "running_other": "{{count}} Runs still working",
      "started_since_one": "{{count}} Run started since the list",
      "started_since_other": "{{count}} Runs started since the list",
      "written_since_one": "{{count}} Run written to since the list",
      "written_since_other": "{{count}} Runs written to since the list"
    },
    "keptBy": "Kept by",
    "keptReason": "Kept by what the list names",
    "title": "Remove “{{title}}”?",
    "unlisted": "What goes could not be listed"
  },
  "rename": {"label": "Title", "save": "Rename", "title": "Rename"},
  "routeNotReady": {
    "not_installed": "{{agent}} isn't installed on {{pc}}. Set it up there and try again.",
    "not_logged_in": "{{agent}} isn't signed in on {{pc}}. Sign in there."
  },
  "runGraph": {
    "count": {
      "annotations_one": "{{count}} annotation",
      "annotations_other": "{{count}} annotations",
      "instance_data_one": "{{count}} statement",
      "instance_data_other": "{{count}} statements",
      "other_one": "{{count}} item",
      "other_other": "{{count}} items",
      "text_units_one": "{{count}} text unit",
      "text_units_other": "{{count}} text units"
    },
    "groupSettled": "{{settled}} of {{steps}} steps done",
    "label": "Run graph",
    "noWorkflow": "No process schema",
    "openRun": "Open the Run beside",
    "tabTitle": "Run graph: {{title}}",
    "workflow": "Process schema: {{name}}"
  },
  "search": {
    "entry": "Run entry #{{number}}",
    "label": "Search Runs",
    "none": "Nothing matches “{{query}}”.",
    "placeholder": "Search Runs…",
    "results": "Search results",
    "searching": "Searching…",
    "titleMatch": "Title"
  },
  "start": {
    "coreReadOnly": "This is DMW's own project. For now it can only be read, so nothing can be started here. Start your work in <projects>one of your projects</projects>."
  },
  "status": {
    "approval": {
      "explanation": "A tool waits for the owner of the PC this Run runs on to approve it. Its step runs once it is approved.",
      "label": "Pending approval"
    },
    "closed": {"explanation": "Read-only. It can still be forked.", "label": "Closed"},
    "failed": {
      "explanation": "The last turn or a step failed. Open the Run to see why.",
      "label": "Failed"
    },
    "input": {
      "explanation": "A person step waits for an answer from a participant.",
      "label": "Input"
    },
    "live": {
      "explanation": "The DMW Connector of the PC it runs on is online; the agent can answer.",
      "label": "Connected"
    },
    "saved": {
      "explanation": "No DMW Connector runs this Run now. Only the person on whose PC it runs can write; others can fork it.",
      "label": "Not connected"
    },
    "waiting": {
      "explanation": "Its turn waits for free capacity on the PC it runs on and starts by itself once there is some.",
      "label": "Waiting"
    },
    "working": {"explanation": "The agent is working on a turn.", "label": "Working"}
  },
  "stepStates": {
    "done": "Done",
    "failed": "Failed",
    "input": "Input",
    "offline": "PC offline",
    "queued": "Waiting to start",
    "ready": "Ready",
    "running": "Running",
    "skipped": "Skipped",
    "upcoming": "Upcoming",
    "waiting": "Waiting",
    "waitingForApproval": "Waiting for approval"
  },
  "steps": {
    "before_one": "{{count}} step before",
    "before_other": "{{count}} steps before",
    "bindingsName": "Project bindings",
    "boundBy": "{{slot}}: the project's {{role}}",
    "changeBound": "Change",
    "changeBoundHint": "Choose other items for {{items}} in the project's bindings",
    "label": "Process schema steps",
    "openRun": "Open the run graph beside",
    "reads": "Reads",
    "runAll": "Run all",
    "runToHere": "Run to here",
    "runningTo": "Running to {{step}}",
    "skips": "Skips {{steps}}",
    "stop": "Stop",
    "stopBeforeAgentSteps": "Stop before agent steps",
    "takes": "Takes {{inputs}}",
    "technical": "Prompt and wiring"
  },
  "switch": {
    "attach": "Choose a process schema…",
    "batchItem": "This Run belongs to a batch, so it keeps the batch's process schema.",
    "busy": "Finish or cancel the running step first.",
    "confirm": "Switch to “{{workflow}}”",
    "earlier": "“{{workflow}}”, left after “{{step}}”",
    "earlierUnsettled": "“{{workflow}}”, left",
    "madeBy": "{{kind}} from “{{step}}”",
    "madeChoice": "{{made}} · #{{entry}}: {{preview}}",
    "made_one": "Output so far · {{count}}",
    "made_other": "Outputs so far · {{count}}",
    "missingNow": "Missing now: {{inputs}}",
    "neededLater": "Needed later: {{inputs}}",
    "none": "No process schema takes these outputs.",
    "open": "Switch process schema…",
    "outputFor": "Output for “{{input}}”",
    "someWorkflow": "another process schema",
    "switching": "Switching…",
    "uses": "Uses {{outputs}}",
    "withdraws": "Switching withdraws the request waiting for an answer."
  },
  "takeOver": {
    "ask": "Ask {{host}}",
    "explanation": "{{host}} approves with one click. Its agent then runs on your PC and your subscription, for everyone in this Run.",
    "title": "Run it on your PC instead of {{host}}'s?"
  },
  "talk": {
    "answered": "The agent answered:",
    "asked": "You asked:",
    "cancel": "Cancel",
    "noAnswer": "The agent gave no answer.",
    "open": "Talk with the agent",
    "renews": {
      "annotations": "The agent answers and may revise the annotations; the review then starts again with its result.",
      "instance_data": "The agent answers and may revise the statements; the review then starts again with its result.",
      "result": "The agent answers and may revise the result; the review then starts again with its result."
    },
    "request": "Your question or request to the agent",
    "send": "Send to the agent"
  },
  "toolApproval": {
    "agentsTool": "A tool the agent asked for",
    "answer": "Check the author, reviewers, runtime and dependencies it shows, then type y to approve.",
    "answerHere": "Answer here or on {{pc}}; the first answer counts. The step runs by itself once approved.",
    "apiEmbedding": "Over an API",
    "approve": "Approve",
    "authorOnly": "By {{author}}; nobody else reviewed it.",
    "byReviewed": "By {{author}}, reviewed by {{reviewers}}.",
    "copyCommand": "Copy the command",
    "copyVersion": "Copy the tool version",
    "decline": "Decline",
    "dependenciesNone": "None",
    "detailDependencies": "Dependencies",
    "detailLimits": "Limits",
    "detailModel": "Embedding model",
    "detailReads": "Reads",
    "detailRuntime": "Runtime",
    "detailSdk": "Tool helpers",
    "detailVersion": "Version",
    "details": "Details",
    "hostPc": "the PC this Run runs on",
    "inTerminal": "In a terminal on that PC:",
    "limits": "{{seconds}} s, {{memory}} MB memory, {{output}} MB output",
    "localEmbedding": "Local",
    "message": "Only the owner of the PC this Run runs on can allow this new tool version.",
    "nodeOnly": "Node's built-in modules only",
    "notThisPc": "Runs on {{pc}}, not on this PC.",
    "openApprovalsOn": "Open the approvals on {{pc}}",
    "outcomes": {
      "approved": "Approved. {{pc}} runs the step now.",
      "declined": "Declined. The step does not run on {{pc}}.",
      "expired": "This request has expired. It comes back when the step asks again.",
      "noAnswer": "{{pc}} did not answer. Try again, or answer on {{pc}}.",
      "notOwner": "Only the account {{pc}} is paired with can answer.",
      "notPending": "Already answered, on {{pc}} or here; nothing changed.",
      "updateNeeded": "Update the DMW Connector on {{pc}} to answer here; until then, answer on {{pc}}."
    },
    "readsSources": "the project's source documents",
    "reviewedBy": "Reviewed by {{reviewers}}.",
    "sdkNew": "{{version}} from the DMW server, new on this PC",
    "serverDefaults": "The server's defaults",
    "title": "Approve {{tool}} on the PC this Run runs on",
    "unknownVouch": "Who wrote and reviewed it is not known.",
    "useCommand": "Use a command instead",
    "version": "Tool {{tool}}, version {{version}}",
    "waiting": "Waiting for approval on {{pc}}. The step runs automatically after approval.",
    "wantsToRun": "{{tool}} wants to run on {{pc}}"
  },
  "toolCall": {
    "failed": "{{tool}} failed: {{reason}}",
    "failureStatus": "Failed",
    "generic": "Called {{tool}}",
    "input": "Input",
    "ok": "Succeeded",
    "output": "Output",
    "summary": "Tool {{tool}}: {{outcome}}, {{milliseconds}} ms"
  },
  "toolCalls": {
    "count_one": "{{count}} tool call",
    "count_other": "{{count}} tool calls",
    "failed_one": "{{count}} failed",
    "failed_other": "{{count}} failed",
    "worked_one": "Worked {{duration}} · {{count}} tool call",
    "worked_other": "Worked {{duration}} · {{count}} tool calls"
  },
  "toolStep": {
    "awaitingApproval": "waiting for approval",
    "checks": {
      "cannotRun_one": "{{count}} could not run",
      "cannotRun_other": "{{count}} could not run",
      "failed_one": "{{count}} failed",
      "failed_other": "{{count}} failed",
      "notChecked_one": "{{count}} not checked",
      "notChecked_other": "{{count}} not checked",
      "passed_one": "{{count}} passed",
      "passed_other": "{{count}} passed"
    },
    "code": "Code",
    "codeOf": "Code of {{tool}}",
    "offline": "waiting for the PC this Run runs on",
    "queued": "waiting to start",
    "running": "running…",
    "waitingForSlot": "waiting for free capacity"
  },
  "toolTurn": {
    "browseTerms": "Browse in the Data model",
    "byteCount_one": "{{count}} byte",
    "byteCount_other": "{{count}} bytes",
    "documents_one": "{{count}} document for the Run's corpus, uploaded",
    "documents_other": "{{count}} documents for the Run's corpus, uploaded",
    "duration": "Duration",
    "fileCount_one": "{{count}} file",
    "fileCount_other": "{{count}} files",
    "inputFileLabel": "Workspace file for {{input}}",
    "memoized": "Recorded outputs reused",
    "more_one": "and {{count}} more",
    "more_other": "and {{count}} more",
    "newItem": "A new {{kind}}, to be proposed for review",
    "onRuntime": "on the DMW Connector ({{runtime}})",
    "onServer": "on the server",
    "openItem": "Open the item",
    "output": "Output {{part}}",
    "outputs": "Outputs:",
    "parameters": "Tool parameters",
    "requested": "{{step}} requested, {{route}}:",
    "requestedWithoutStep": "Tool run requested, {{route}}:",
    "score": "score {{score}}",
    "sourceVersionSummary": "{{source}} · {{commit}} · {{files}}, {{bytes}}",
    "terms_one": "{{count}} ontology term.",
    "terms_other": "{{count}} ontology terms.",
    "title": "Tool run",
    "value": "Show the value",
    "valueKinds": {
      "annotations": "Annotations",
      "change_set": "Change set",
      "check_report": "Check report",
      "choice": "Choice",
      "corpus_import": "Corpus import",
      "derived": "Derived data",
      "derived_records": "Derived records",
      "html_page": "HTML page",
      "instance_data": "Statements",
      "item": "Item",
      "item_refs": "Item references",
      "memory": "Memory",
      "release": "Data release",
      "release_request": "Release request",
      "result": "Result",
      "source_version": "Source version",
      "term_cards": "Term cards",
      "text": "Text",
      "text_units": "Text units",
      "workspace_file": "Workspace file"
    }
  },
  "turn": {
    "agent": "Agent",
    "agentOnly": "agent {{agent}}",
    "agentRoute": "agent {{agent}}, {{model}}",
    "agentSetup": {
      "counts": "{{skills}}, {{servers}}, {{files}}",
      "digest": "Setup digest",
      "dmw_only": "Ran with DMW only",
      "extend": "Ran with your setup + DMW",
      "files_one": "{{count}} instruction file",
      "files_other": "{{count}} instruction files",
      "hooks": "Hooks",
      "memory": "Agent memory",
      "memoryRead": "read: {{read}}, saving: off",
      "memoryStates": {"off": "off", "on": "on"},
      "personalSkills": "Personal skills",
      "plugins": "Plugins",
      "serverLoaded": "{{name}} (loaded)",
      "serverOff": "{{name}} (not ticked, off)",
      "servers": "MCP servers",
      "servers_one": "{{count}} MCP server",
      "servers_other": "{{count}} MCP servers",
      "skills_one": "{{count}} personal skill",
      "skills_other": "{{count}} personal skills",
      "title": "Agent setup",
      "tryDmwOnly": "Try with DMW only",
      "tryDmwOnlyHelp": "Runs this again without your own instructions, skills, MCP servers and plugins, to see whether they caused the failure."
    },
    "answers": "Answers request",
    "apiRoute": "API {{route}}, {{model}}",
    "askedAgent": "Asked the agent: {{what}}",
    "basedOn": "Input reflects up to",
    "capabilitiesUnknown": "DMW did not know the LLM's {{capabilities}} when this turn started; it ran anyway.",
    "covers": "Hands over {{entries}}.",
    "defaultModel": "the agent's default LLM",
    "details": "Details",
    "inputPurposes": {
      "agent_instructions": "Agent instructions",
      "history_preamble": "History so far",
      "pending_messages": "Messages handed over",
      "step_instructions": "Step's agent instructions",
      "step_prompt": "Step prompt",
      "turn_note": "Note"
    },
    "localToolCall": "{{title}} ({{kind}}, {{status}})",
    "outcome": "Outcome",
    "outcomes": {"cancelled": "Cancelled", "completed": "Completed", "failed": "Failed"},
    "output": "Output",
    "permissionProfile": "Permission profile",
    "providerContact": "Provider reached",
    "providerContacts": {"confirmed": "yes", "none": "no", "possible": "maybe"},
    "redacted": "Secrets were removed from the result: {{patterns}}.",
    "reply": "a reply",
    "route": "Runs with",
    "session": "Session",
    "sessionModes": {
      "continue": "continued",
      "fresh": "fresh",
      "isolated": "isolated",
      "resume": "resumed"
    },
    "talkContinuations": {
      "rebuilt": "The agent's session couldn't be continued; it was given the earlier exchange instead.",
      "resumed": "In the agent's own session.",
      "thread": "In the Run's session."
    },
    "talked": "Talked with the agent of {{what}}",
    "tools": "Tools"
  },
  "turnActivity": {
    "agentsAtOnce_one": "It runs one agent at a time.",
    "agentsAtOnce_other": "It runs at most {{count}} agents at once.",
    "awaitingApproval": "Waiting for its tool's approval",
    "changeAgentsAtOnce": "Change it on {{pc}}",
    "fetchingModel": "Downloading the embedding model",
    "hostOffline": "Waiting for the PC this Run runs on to reconnect",
    "modelReceived": "{{megabytes}} MB",
    "toolRunning": "Tool running",
    "waitingForSlot": "Waiting for free capacity on {{pc}}",
    "workDone": "{{done}} of {{total}}"
  },
  "turnStates": {
    "cancelled": "Cancelled",
    "cancelling": "Cancelling",
    "completed": "Completed",
    "dispatched": "Sent to the DMW Connector",
    "failed": "Failed",
    "queued": "Waiting to start",
    "running": "Agent working"
  },
  "usage": {
    "cost": "Cost {{cost}}",
    "summary": "Tokens in {{input}}, out {{output}}, cached {{cached}}, cost {{cost}}",
    "title": "Usage",
    "tokens": "Tokens in {{input}}, out {{output}}, cached {{cached}}",
    "unknown": "unknown"
  },
  "versions": {
    "compaction": "Shortened",
    "corpusVersion": "Corpus version",
    "historyPreamble": "History method",
    "inputEntries": "Input entries",
    "prompt": "Prompt",
    "reduced": "shortened, level {{level}}",
    "step": "Step",
    "subject": "Document",
    "workflow": "Process schema"
  },
  "waits": {
    "changeSetCurators": "Waits for a curator of the change.",
    "host": "Waits for {{name}}'s answer.",
    "hostTurn": "Waiting for {{name}}",
    "memoryOwner": "Waits for the memory's owner.",
    "participants": "Waits for an answer from someone who may write in this Run.",
    "resultCurators": "Waits for a curator of the result.",
    "workflowLeft": "Waits for {{name}} to resume the process schema.",
    "workflowLeftHost": "Left the process schema; this step still waits. Resume the process schema to answer it.",
    "yours": "Waits for your answer."
  },
  "workflow": {
    "completed": "Completed",
    "condition": "{{step}}: {{state}}",
    "conditionState": {"satisfied": "met", "undetermined": "open", "unsatisfied": "not met"},
    "leave": "Leave process schema",
    "left": "Left",
    "outcome": {
      "satisfied": "Outcome met",
      "undetermined": "Outcome open",
      "unsatisfied": "Outcome not met"
    },
    "resume": "Resume process schema",
    "unnamed": "Process schema"
  }
}
